import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

/**
 * Route guard that renders children only when the effective role satisfies
 * `requires`.
 *
 *   <RoleGuard requires="account_admin">...</RoleGuard>
 *   <RoleGuard requires={["account_admin", "account_member"]}>...</RoleGuard>
 */
const RoleGuard = ({ requires, children, fallback = '/login' }) => {
  const auth = useSelector((state) => state.guardian.auth);
  const { isAuthenticated, isLoading, role } = auth;

  if (isLoading) return null;
  if (!isAuthenticated) return <Redirect to={fallback} />;

  const required = Array.isArray(requires) ? requires : [requires];

  if (required.includes(role)) {
    return children;
  }

  return <Redirect to="/" />;
};

export default RoleGuard;
